import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mzd-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class MzdIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
